import { useRef, useEffect, useState } from "react";
import { Hero } from "./components/landingpage/Hero";
import { Struggle } from "./components/landingpage/Struggle";
import { BotSection } from "./components/landingpage/BotSection";
import { HowItWorks } from "./components/landingpage/HowItWorks";
import { WhyUs } from "./components/landingpage/WhyUs";
import styles from "./styles/LandingPage.module.css";
import { MeetXenorize } from "./components/landingpage/MeetXenorize";
import { EffortlessTrading } from "./components/landingpage/EffortlessTrading";
import { Subscription } from "./components/landingpage/Subscription";
import BotIntroduction from "./components/landingpage/BotIntroduction";
import Learn from "./components/landingpage/Learn";
import { Join } from "./components/landingpage/Join";
import KnowFAQ from "./components/landingpage/KnowFAQ";
import JoinWaitlist from "./components/landingpage/JoinWaitlist";
import { Helmet } from "react-helmet";
import SmartTradingPartner from "./components/landingpage/SmartTradingPartner";
import TradingStrategy from "./components/landingpage/TradingStrategy";
import PerformanceMetrics from "./components/landingpage/PerformanceMetrics";
import TradeHistory from "./components/landingpage/TradeHistory";
import BotStrength from "./components/landingpage/BotStrength";
import EffortlessCryptoTrading from "./components/landingpage/EffortlessCryptoTrading";
import TrustedPartner from "./components/landingpage/TrustedPartner";
import StrongTogether from "./components/landingpage/StrongTogether";

export const LandingPage = ({ scrollToSection, botRef, joinRef, learnRef }) => {
  const joinWaitlist = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  useEffect(() => {
    const width = window.innerWidth;

    if (width < 768) {
      setPopupImage("/images/Xenorushs2PopupMobile.png");
    } else if (width >= 768 && width < 1024) {
      setPopupImage("/images/Xenorushs2PopupTablet.png");
    } else {
      setPopupImage("/images/Xenorushs2PopupDesktop.png");
    }

    const timer = setTimeout(() => setShowPopup(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.landingPage}>
      <Helmet>
        <title>
          Xenorize | Crypto Ecosystem to Trade, Learn & Grow Together
        </title>
        <meta
          name="description"
          content="Join Xenorize - a complete crypto trading ecosystem combining smart bots, educational content, and a supportive community to help you trade with confidence."
        />
        <meta
          name="keywords"
          content="crypto trading, automated bot, crypto community, learn crypto, beginner crypto, Xenorize, trading made easy"
        />
        <link rel="canonical" href="https://xenorize.com/" />
      </Helmet>
      {/* <Navbar scrollToSection={scrollToSection} botRef={botRef} joinRef={joinRef} learnRef={learnRef} /> */}
      <main className={styles.main}>
        <Hero
          scrollToSection={scrollToSection}
          joinWaitlistRef={joinWaitlist}
        />
        <SmartTradingPartner />
        <TradingStrategy botRef={botRef} />
        {/* <PerformanceMetrics /> */}
        {/* <TradeHistory /> */}
        <BotStrength />
        {/* <Struggle /> */}
        {/* <MeetXenorize
          scrollToSection={scrollToSection}
          botRef={botRef}
          joinRef={joinRef}
          learnRef={learnRef}
          joinWaitlistRef={joinWaitlist}
        /> */}
        <EffortlessCryptoTrading />
        <TrustedPartner />
        {/* <StrongTogether /> */}
        {/* <EffortlessTrading /> */}
        {/* <Subscription /> */}
        {/* <div ref={joinWaitlist}>
          <JoinWaitlist />
        </div> */}
        {/* <div ref={botRef}>
          <BotIntroduction
            scrollToSection={scrollToSection}
            joinWaitlistRef={joinWaitlist}
          />
        </div> */}
        {/* <div ref={learnRef}>
          <Learn />
        </div> */}
        {/* <div ref={joinRef}>
          <Join
            scrollToSection={scrollToSection}
            joinWaitlistRef={joinWaitlist}
          />
        </div> */}
        {/* <KnowFAQ /> */}
        {/* <BotSection /> */}
        {/* <HowItWorks /> */}
        {/* <WhyUs /> */}
      </main>
      {/* <Footer /> */}
      {/* {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowPopup(false)}
        >
          <img
            src={popupImage}
            alt="Xenorush Promotion"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              cursor: "pointer",
              borderRadius: "8px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = "/xenorush";
            }}
          />
        </div>
      )} */}
    </div>
  );
};

export default LandingPage;
